import * as React from 'react'
import { Theme } from '@mui/material/styles'
import { FC, useMemo } from 'react'
import { IDiscountLineItem } from '@user/store/discountCode/typings'
import { discountAmountString } from '../discountAmountString'

import { DataItem } from '@sales-center/components'
import Grid from '@mui/material/Grid'
import Card from '@mui/material/Card'

interface Props {
  discountLineItem: IDiscountLineItem
}

const styles = {
  card: {
    boxShadow: '0px 2px 7px 3px rgba(226, 226, 226, 0.5)',
    '&:not(:last-child)': {
      marginBottom: (theme: Theme) => theme.spacing(2.4),
    },
    padding: (theme: Theme) => theme.spacing(1.5),
  },
}

export const DiscountLineItemCard: FC<Props> = (props) => {
  const {
    discountLineItem: { amount, amountType, services },
  } = props

  const serviceType = useMemo(() => {
    const isServiceClass = services.some((x) => x.serviceClass)
    return isServiceClass ? 'Service Class' : 'Service'
  }, [services])

  const serviceCodesCsv = useMemo(
    () =>
      services
        .map((service) => service.serviceCode || service.serviceClass)
        .join(', '),
    [services],
  )

  return (
    <Card sx={styles.card} style={{ width: 'auto' }}>
      <Grid container spacing={4}>
        <DataItem title="Discount">
          {discountAmountString(amount, amountType)}
        </DataItem>
        <DataItem title="Service Type">{serviceType}</DataItem>
        <DataItem title="Service / Class" style={{ maxWidth: 300 }}>
          {serviceCodesCsv}
        </DataItem>
      </Grid>
    </Card>
  )
}
